export default __webpack_public_path__ + "static/media/certificate.4048240c.png";